import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { tap } from 'rxjs';
import { ModelService } from '../services/model.service';
import { Gen_Model } from '../types/generated-model.type';

interface IServerModelStateModel {
  loading: boolean;
  models?: Gen_Model[];
  selectedModel?: Gen_Model;
}
export class LoadModels {
  static readonly type = '[IserverModel] Load Models';
}
@Injectable()
@State<IServerModelStateModel>({
  name: 'iservermodel',
  defaults: {
    loading: false,
  },
})
export class IServerModelState {

  constructor(private modelService: ModelService, private store: Store) {
  }

  @Selector()
  static models(state: IServerModelStateModel): Gen_Model[] {
    return state.models!;
  }

  @Selector()
  static loading(state: IServerModelStateModel): boolean {
    return state.loading;
  }

  @Action(LoadModels)
  loadModels(ctx: StateContext<IServerModelStateModel>) {
    ctx.patchState({ loading: true });
    return this.modelService.getModels().pipe(tap(models => {
      ctx.patchState({ models, loading: false })
    }));
  }
}
